import React, { useEffect, useState } from "react";
import styles from './Home.module.scss';
import PageTitle from "../../../components/pageTitle/PageTitle";
import DashboardCard from "../../../components/dashboardCard/DashboardCard";
import { Link } from "react-router-dom";
import DashboardStudentCard from "../../../components/dashboardStudentCard/DashboardStudentCard";
import LoadingOverlay from "../../../components/loadingOverlay/LoadingOverlay";
import axiosClient from "../../../api/axiosClient";
import { useToasts } from "../../../contexts/ToastContext";

const Home = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const { showToast } = useToasts();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await axiosClient.get(`dashboard/instructor`)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsLoading(false);
      });
    };

    fetchData();
  }, [showToast]);

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <PageTitle
          label="Home"
        />
      </div>
      <div className={styles.container}>
        <h2>Evaluation Summary</h2>
        <div className={styles.cardList}>
          <div className={styles.cardItem}>
            <DashboardCard
              title='Evaluations Completed'
              progress={{
                total: data?.totalEvaluations ?? 0,
                completed: data?.completedEvaluations ?? 0,
                color: '#388147'
              }}
              daysText="Last 7 Days"
            />
          </div>
          <div className={styles.cardItem}>
            <DashboardCard
              title='Evaluation Requests'
              progress={{
                total: data?.totalEvaluationRequests ?? 0,
                completed: data?.acceptedEvaluationRequests ?? 0,
                color: '#171898'
              }}
              daysText="Last 7 Days"
            />
          </div>
          <div className={styles.cardItem}>
            <DashboardCard
              title='Critical Evaluation'
              count={{
                icon: 'clipboard',
                count: data?.criticalEvaluations ?? 0,
                type: 'orange'
              }}
              daysText="Next 48 Hours"
            />
          </div>
          <div className={styles.cardItem}>
            <DashboardCard
              title='Overdue Evaluations'
              count={{
                icon: 'clipboard',
                count: data?.overdueEvaluations ?? 0,
                type: 'red'
              }}
              daysText="Last 7 Days"
            />
          </div>
        </div>
        <h2>My Students ({data?.totalMyStudents ?? 0}) <Link to="/students">View All Students</Link></h2>
        <div className={styles.studentSections}>
          <div className={styles.studentList}>
            {data?.myStudents && data?.myStudents.length > 0 ? data?.myStudents.map((student, index) => (
              <div className={styles.studentItem} key={`student-${index}`}>
                <DashboardStudentCard
                  student={{
                    id: student.studentId,
                    profilePicture: student.profilePicture,
                    firstName: student.firstName,
                    lastName: student.lastName
                  }}
                  completed={student?.pendingEvaluations ?? 0}
                  total={student?.totalEvaluations ?? 0}
                />
              </div>
            )) : !isLoading && <div className={styles.emptyList}>
              <p>No students available</p>
            </div>}
          </div>
          <div className={styles.studentCards}>
            <DashboardCard
              title='Students Evaluated This Year'
              students={{
                list: data.studentsEvaluatedThisYear ?? [],
                count: (data?.studentsEvaluatedThisYearCount?? 0) - (data?.studentsEvaluatedThisYear ? data.studentsEvaluatedThisYear.length :  0)
              }}
            />
            <DashboardCard
              title='Total Clinical Hours This Year'
              count={{
                count: 0,
                icon: 'clock',
                text: 'Hours',
                type: 'primary'
              }}
            />
            <DashboardCard
              title='Evaluations Completed This Year'
              count={{
                icon: 'clipboard',
                count: data?.evaluationsCompletedThisYear ?? 0,
                type: 'green'
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
